module.exports = __webpack_public_path__ + "img/logo.52ecd8f0.svg";